module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-49.67a88526.jpg";